<template>
  <div :class="$vuetify.breakpoint.smAndUp ? 'pa-4' : 'px-2 pb-4'">
    <div class="heading__class" v-if="$vuetify.breakpoint.smAndUp">Price Summary</div>
    <div :class="$vuetify.breakpoint.smAndUp ? 'py-5' : ''">
      <div class="py-2">
        <div>
          <div class="d-flex">
            <div>
              <div class="title__class">Today’s Low</div>
              <div class="value__class">₹{{ item.low.toFixed(2) }}</div>
            </div>
            <v-spacer></v-spacer>
            <div>
              <div class="title__class">Today’s High</div>
              <div class="value__class">₹{{ item.high.toFixed(2) }}</div>
            </div>
          </div>
        </div>
        <!-- <progress
          :min="item.low"
          :value="item.live_price"
          :max="item.low"
          style="width: 100%"
        ></progress> -->
        <div style="position: relative" class="pt-5">
          <progress-bar-stepper
            :price="item.live_price"
            :high="item.todays_high"
            :low="item.todays_low"
          ></progress-bar-stepper>
        </div>
      </div>
      <div class="py-2">
        <div>
          <div class="d-flex">
            <div>
              <div class="title__class">52 Week Low</div>
              <div class="value__class" v-if="item.fiftytwo_low">
                ₹{{ item.fiftytwo_low.toFixed(2) }}
              </div>
            </div>
            <v-spacer></v-spacer>
            <div>
              <div class="title__class">52 Week High</div>
              <div class="value__class">₹{{ item.fiftytwo_high.toFixed(2) }}</div>
            </div>
          </div>
        </div>
        <!-- <progress
          :min="item.fiftytwo_low"
          :value="item.live_price"
          :max="item.fiftytwo_high"
          style="width: 100%"
        ></progress> -->
        <div style="position: relative" class="pt-5">
          <progress-bar-52
            :price="item.live_price"
            :high="item.fiftytwo_high"
            :low="item.fiftytwo_low"
          ></progress-bar-52>
        </div>
      </div>
    </div>
    <v-row>
      <v-col cols="4" class="text-center d-flex justify-center border_right__class">
        <div>
          <div class="title__class">Open</div>
          <div class="value__class">₹{{ item.open.toFixed(2) }}</div>
        </div>
      </v-col>
      <v-col cols="4" class="text-center d-flex justify-center border_right__class">
        <div>
          <div class="title__class">Prev. Close</div>
          <div class="value__class">₹{{ item.close.toFixed(2) }}</div>
        </div>
      </v-col>
      <v-col cols="4" class="text-center d-flex justify-center">
        <div>
          <div class="title__class">Volume</div>
          <div class="value__class">{{ item.volume | addCommasInNumber }}</div>
        </div>
      </v-col>
    </v-row>
    <!-- <div class="d-flex justify-center text-center space-between py-5">
      <div class="px-4 text-center border_right__class">
        <div class="title__class">Open</div>
        <div class="value__class">₹{{ item.open.toFixed(2) }}</div>
      </div>
      <div class="px-4 text-center border_right__class">
        <div class="title__class">Prev. Close</div>
        <div class="value__class">₹{{ item.close.toFixed(2) }}</div>
      </div>
      <div class="px-4 text-center">
        <div class="title__class">Volume</div>
        <div class="value__class">{{ item.volume }}</div>
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  name: "PriceSummary",
  components: {
    ProgressBarStepper: () => import("../ProgressBarStepper/ProgressBarStepper.vue"),
    ProgressBar52: () => import("../ProgressBarStepper/ProgressBar52.vue"),
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  mounted() {},
};
</script>
<style scoped>
.heading__class {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 800;
  font-size: 18px;
  line-height: 25px;
  /* identical to box height */

  display: flex;
  align-items: center;

  color: #4d4d4d;
}
.title__class {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  /* identical to box height */

  display: flex;
  align-items: center;

  color: #848484;
}
.value__class {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  /* identical to box height */

  display: flex;
  align-items: center;
  text-align: right;

  color: #2b2b2b;
}
.border_right__class {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}
.border_left__class {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}
progress {
  -webkit-appearance: none;
  height: 5px;
  border-radius: 50%;
}
::-webkit-progress-value {
  background-color: #2d8cff;
}

::-moz-progress-bar {
  background-color: #2d8cff;
}
</style>
